import React, { useContext, useEffect, useState } from "react";
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useNavigation,
} from "react-router-dom";
import { ERROR_MESSAGES } from "../GlobalErrorMessage";
import { AddNewsLetter, NewsletterAPI } from "../../ApiServices/NewsLettter/NewsLetterApi";
import SuccessModal from "../SuccessModal";
import logo from "../../../src/assets/images/new/newLogo.jpg";
import ComingSoonModal from "../ComingSoonModal";
import { t } from "i18next";
import { AuthContextProvider, LoaderContext } from "../../AuthContext/AuthContext";
import LoginPopUp from "../LoginPopup";
const Footer = () => {
  const { selectedLanguageID } = useContext(LoaderContext);
  const { isAuthenticated } = useContext(AuthContextProvider);
  const navigate = useNavigate();


  const [error, setError] = useState(null);
  const location = useLocation();
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(null);
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);
  const userID = localStorage.getItem("userID") || "";
  const userKeyID = localStorage.getItem("userKeyID") || "";
  const [Action, setAction] = useState(false);
  const [showLoginPopUp, setShowLoginPopUp] = useState(null);
  const [newsLetterObj, setNewsLetterObj] = useState({
    firstName: null,
    lastName: null,
    email: null,
  });

  useEffect(() => {
    setInitialData();
  }, [location]);

  const handleSubscribe = () => {
    let isValid = false;
    if (
      newsLetterObj.firstName === "" ||
      newsLetterObj.firstName === null ||
      newsLetterObj.firstName === undefined ||
      newsLetterObj.lastName === "" ||
      newsLetterObj.lastName === null ||
      newsLetterObj.lastName === undefined ||
      newsLetterObj.email === "" ||
      newsLetterObj.email === null ||
      newsLetterObj.email === undefined
    ) {
      setError(true);
      isValid = true;
    } else if (
      newsLetterObj.email !== null &&
      newsLetterObj.email !== undefined &&
      newsLetterObj.email !== "" &&
      !isValidEmail(newsLetterObj.email)
    ) {
      setError(true);
      isValid = true;
    }

    const api_params = {
      fName: newsLetterObj.firstName,
      lName: newsLetterObj.lastName,
      email: newsLetterObj.email,
      userKeyID: userKeyID || null,
    };

    if (!isValid) {
      addUpdateNewsLetter(api_params);
    }
  };

  const addUpdateNewsLetter = async (api_params) => {
    try {
      const response = await AddNewsLetter(api_params);

      if (response?.statusCode === 200) {
        setShowSuccessPopUp(true);

      }
    } catch (error) {
      console.log(error);
    }
  };

  const setInitialData = () => {
    setError(false);
    setNewsLetterObj((prev) => ({
      ...prev,
      firstName: "",
      lastName: "",
      email: "",
    }));
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const closeAll = () => {

    setShowSuccessPopUp(false);
    setInitialData();
    // window.location.reload();
  };

  let date = new Date();
  let n = date.getYear();

  const handleAstrologyClicked = () => {

    if (!isAuthenticated) {
      setShowLoginPopUp(true);
    } else {
      navigate('/horoscope-detail');
      window.scrollTo(0, 0)
    }

  }

  return (
    <>
      <footer className="" style={{ backgroundColor: "#A52444" }}>
        <div className="container">
          <div
            className=""
            style={{
              // backgroundImage: `url('assets/images/backgrounds/footer-bg-1-1.jpg')`,
              position: "absolute",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
              backgroundSize: "cover",
              backgroundPosition: "center",
              zIndex: "-1",
            }}
          ></div>

          <div className="" style={{ margin: "0px", marginTop: "0px" }}>
            <div className="row">
              {/* About us */}
              <div
                className="col-12 col-md-12 col-xl-3 wow fadeInUp"
                data-wow-delay="100ms"
              >
                <div className="footer-widget footer-widget--about footert">
                  <div className="footer-widget__logo">
                    <img src={logo} width="223" alt="myom namo" className="footer-logo" />
                  </div>
                  <p className="footer-widget__text">
                    {t(
                      "Myomnamo is an earnest venture to solve the problem by synergizing your spiritual and professional world. We assure to bring you closer to the veteran pandit who would guide you in the rituals."
                    )}
                  </p>

                  <div className="footer-widget__social">
                    <style>{`
    .footer-widget__social a i {
      color: white;
    }
  `}</style>
                    <a
                      href="https://www.facebook.com/omnamoapp/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ "--accent-color": "#ffa415" }}
                    >
                      <i
                        className="fab fa-facebook-f"
                        aria-hidden="true"
                        target="_blank"
                        rel="noopener noreferrer"
                      ></i>
                      <span className="sr-only">{t("Facebook")}</span>
                    </a>
                    <a
                      href="https://www.linkedin.com/company/my-om-namo/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ "--accent-color": "#44c895" }}
                    >
                      <i
                        className="fa-brands fa-linkedin"
                        aria-hidden="true"
                        target="_blank"
                        rel="noopener noreferrer"
                      ></i>
                      <span className="sr-only">{t("LinedIn")}</span>
                    </a>
                    <a
                      href="https://www.instagram.com/myomnamo_official/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ "--accent-color": "#44c895" }}
                    >
                      <i
                        className="fa-brands fa-instagram"
                        aria-hidden="true"
                        target="_blank"
                        rel="noopener noreferrer"
                      ></i>
                      <span className="sr-only">{t("Instagram")}</span>
                    </a>
                    <a
                      href="https://x.com/My_OmNamo"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ "--accent-color": "#44c895" }}
                    >
                      <i
                        className="fa-brands fa-x-twitter"
                        aria-hidden="true"
                        target="_blank"
                        rel="noopener noreferrer"
                      ></i>
                      <span className="sr-only">X</span>
                    </a>
                    <a
                      href="https://www.youtube.com/@Myomnamo"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ "--accent-color": "#44c895" }}
                    >
                      <i
                        className="fa-brands fa-youtube"
                        aria-hidden="true"
                        target="_blank"
                        rel="noopener noreferrer"
                      ></i>
                      <span className="sr-only">{t("Youtube")}</span>
                    </a>
                  </div>
                </div>
              </div>
              {/* Quick links */}
              <div
                className="col-6 col-md-6 col-xl-2 wow fadeInUp"
                data-wow-delay="200ms"
              >
                <div className="footer-widget footer-widget--links-two footert">
                  <h2 className="footer-widget__title">{t("Quick Link")}</h2>
                  <ul
                    className="list-unstyled footer-widget__links"
                    style={{ marginLeft: "3px" }}
                  >
                    <li>
                      <a href="/">{t("Home")}</a>
                    </li>
                    <li>
                      <a href="/about-us">{t("About Us")}</a>
                    </li>
                    <li>
                      <a href="/spiritual-gyan">{t("Spiritual Gyan")}</a>
                    </li>
                    <li>
                      <a href="/faq">{t("FAQ's")}</a>
                    </li>
                    <li>
                      <a href="/contact-us">{t("Contact Us")}</a>
                    </li>
                    <li>
                      <a href="/become-pandit">{t("Become Pandit")}</a>
                    </li>
                    <li>
                      <a href="/terms-and-condition">
                        {t("Terms And Conditions")}
                      </a>
                    </li>
                    <li>
                      <a href="/privacy-policy">{t("Privacy Policies")}</a>
                    </li>
                    <li>
                      <a href="/refund-policy">{t("Refund Policy")}</a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Services */}
              <div
                className="col-6 col-md-6 col-xl-2 wow fadeInUp service-tochange"
                data-wow-delay="150ms"
              >
                <div className="footer-widget footer-widget--links footert">
                  <h2 className="footer-widget__title">{t("Services")}</h2>
                  <ul
                    className="list-unstyled footer-widget__links"
                    style={{ marginLeft: "3px" }}
                  >
                    <li>
                      <Link
                        to="/remedy-puja"
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        {t("Remedy Puja")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/homam-puja"
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        {t("Homam Puja")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/pandit-puja"
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        {t("Pandit Booking")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/daily-pandit-puja"
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        {t("Daily Pandit (Puja)")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/my-store" onClick={() => window.scrollTo(0, 0)}>
                        {t("E-Store")}
                      </Link>
                    </li>


                    <li>
                      <Link to="/temples" onClick={() => window.scrollTo(0, 0)}>
                        {t("Temples")}
                      </Link>
                    </li>
                    <li onClick={handleAstrologyClicked}>
                      <Link onClick={() => handleAstrologyClicked}>
                        {t("Astrology")}
                      </Link>
                    </li>

                  </ul>
                </div>
              </div>
              {/* Contact Info */}
              <div
                className="col-12 col-md-6 col-xl-2 wow fadeInUp"
                data-wow-delay="250ms"
              >
                <div className="footer-widget footer-widget--contact footert">
                  <h2 className="footer-widget__title">{t("Contact Info")}</h2>
                  <ul
                    className="list-unstyled footer-widget__info"
                    style={{ marginLeft: "0" }}
                  >
                    <li style={{ "--accent-color": "#ffa415" }}>
                      <span className="footer-widget__info__icon">
                        <i
                          className="icon-phone-call"
                          style={{ color: "white" }}
                        ></i>
                      </span>
                      <a href="tel:+919119555461">+91 9119555461</a>
                    </li>
                    {/* <li style={{ "--accent-color": "#ffa415" }}>
                      <span className="footer-widget__info__icon">
                        <i
                          className="icon-phone-call"
                          style={{ color: "white" }}
                        ></i>
                      </span>
                      <a href="tel:+917738581133">+91 7738581133</a>
                    </li> */}

                    <li style={{ "--accent-color": "#ff5528" }}>
                      <span className="footer-widget__info__icon">
                        <i
                          className="icofont-location-pin"
                          style={{ color: "white" }}
                        ></i>
                      </span>
                      {t("Mumbai")}
                    </li>
                    <li style={{ "--accent-color": "#8139e7" }}>
                      <span className="footer-widget__info__icon">
                        <i
                          className="icofont-email"
                          style={{ color: "white" }}
                        ></i>
                      </span>
                      <a
                        style={{ color: "white" }}
                        onMouseEnter={(e) => (e.target.style.color = "white")}
                        onMouseLeave={(e) => (e.target.style.color = "white")}
                        href="mailto:info@myomnamo.com"
                      >
                        info@myomnamo.com
                      </a>
                    </li>

                  </ul>
                </div>
              </div>
              {/* Nes Letter */}
              <div
                className="col-md-6 col-xl-3 wow fadeInUp"
                data-wow-delay="250ms"
              >
                <div className="footer-widget footer-widget--contact footert">
                  {/* Newsletter Section */}
                  <div
                    className="single-nav-area-footer news-letter"
                    style={{ marginTop: "20px" }}
                  >
                    <h2 className="footer-widget__title">{t("Newsletter")}</h2>
                    <p style={{ color: "#f1f1f1", fontSize: "14px" }}>
                      {t("Stay updated with our latest updates.")}
                    </p>
                    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                      <div className="d-flex" style={{ flexWrap: "wrap", width: "100%", gap: "10px" }}>

                        {/* First Name */}
                        <div style={{ display: "flex", flexDirection: "column", flex: "1", width: "100%" }}>
                          <input
                            className="col-6  first-footer"
                            type="text"
                            placeholder={t("First Name")}
                            value={newsLetterObj.firstName}
                            onChange={(e) => {
                              let inputVal = e.target.value;
                              let formattedInput = inputVal.trim().replace(/\s+/g, " ");
                              if (formattedInput === "" || /^[a-zA-Z\s]+$/.test(formattedInput)) {
                                setNewsLetterObj((prev) => ({ ...prev, firstName: formattedInput }));
                              }
                            }}
                            maxLength={30}
                            style={{
                              padding: "10px",
                              borderRadius: "5px",
                              border: "none",
                              fontSize: "14px",
                              outline: "none",
                              width: '100%'
                            }}
                          />
                          {error &&
                            (!newsLetterObj.firstName || newsLetterObj.firstName === "") && (
                              <span className="error-msg" style={{ color: "#ff9900", fontSize: "12px" }}>
                                {t(ERROR_MESSAGES)}
                              </span>
                            )}
                        </div>

                        {/* Last Name */}
                        <div style={{ display: "flex", flexDirection: "column", flex: "1", width: "100%" }}>
                          <input
                            type="text"
                            className="col-6"
                            placeholder={t("Last Name")}
                            value={newsLetterObj.lastName}
                            onChange={(e) => {
                              let inputVal = e.target.value;
                              let formattedInput = inputVal.trim().replace(/\s+/g, " ");
                              if (formattedInput === "" || /^[a-zA-Z\s]+$/.test(formattedInput)) {
                                setNewsLetterObj((prev) => ({ ...prev, lastName: formattedInput }));
                              }
                            }}
                            maxLength={30}
                            style={{
                              padding: "10px",
                              borderRadius: "5px",
                              border: "none",
                              fontSize: "14px",
                              outline: "none",
                              width: '100%'
                            }}
                          />
                          {error &&
                            (!newsLetterObj.lastName || newsLetterObj.lastName === "") && (
                              <span className="error-msg" style={{ color: "#ff9900", fontSize: "12px" }}>
                                {t(ERROR_MESSAGES)}
                              </span>
                            )}
                        </div>
                      </div>

                      {/* Email */}
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <input
                          type="text"
                          placeholder={t("Email Address")}
                          value={newsLetterObj.email}
                          onChange={(e) => {
                            let inputVal = e.target.value;
                            let formattedInput = inputVal.replace(/^\s+/, "");
                            setNewsLetterObj((prev) => ({ ...prev, email: formattedInput }));
                          }}
                          maxLength={50}
                          style={{
                            padding: "10px",
                            borderRadius: "5px",
                            border: "none",
                            fontSize: "14px",
                            outline: "none",
                          }}
                        />
                        {error &&
                          (!newsLetterObj.email || newsLetterObj.email === "") && (
                            <span className="error-msg" style={{ color: "#ff9900", fontSize: "12px" }}>
                              {t(ERROR_MESSAGES)}
                            </span>
                          )}
                        {error && newsLetterObj.email && !isValidEmail(newsLetterObj.email) && (
                          <span className="error-msg" style={{ color: "#ff9900", fontSize: "12px" }}>
                            {t("Please enter a valid email")}
                          </span>
                        )}
                      </div>

                      {/* Button */}
                      <div style={{ width: "100%" }}>
                        <button
                          onClick={handleSubscribe}
                          className="btn-subscribe"
                          style={{
                            backgroundColor: "#ff9900",
                            color: "#000000",
                            border: "none",
                            padding: "10px 15px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                        >
                          {t("Subscribe")}
                        </button>
                      </div>

                      {/* App Buttons */}
                      <div className="app-buttons-footer text-center w-100">
                        <a
                          className="google-play-btn"
                          href="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-google-play"></i>
                          <span>Google Play</span>
                        </a>
                        <a
                          href="https://apps.apple.com/in/app/myomnamo/id6747122767"
                          className="app-store-btn"
                          style={{ cursor: "pointer" }}
                          target="_blank"
                          rel="noopener noreferrer"
                        // onClick={() => setShowComingSoonModal(true)}
                        >
                          <i className="fab fa-apple"></i>
                          <span>App Store</span>
                        </a>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-footer__bottom wow fadeInUp" data-wow-delay="300ms">
          <div>
            <div className="main-footer__bottom__inner">
              <p className="main-footer__copyright">
                &copy; Copyright {new Date().getFullYear()}{" "}
                <span className="dynamic-year"></span> By Myomnamo
              </p>
            </div>
          </div>
        </div>
        <SuccessModal
          show={showSuccessPopUp}
          onHide={() => {
            setInitialData();
            setShowSuccessPopUp(false);
          }}
          onConfirm={closeAll}
          Action={null}
        />
        <ComingSoonModal
          show={showComingSoonModal}
          onClose={() => setShowComingSoonModal(false)}
        />
      </footer>
      <LoginPopUp
        show={showLoginPopUp}
        onHide={() => setShowLoginPopUp(false)}
        setOnGetOTP={() => setShowLoginPopUp(false)}
      />
    </>

  );
};

export default Footer;
